<div class="footer-container">
  <div class="footer-content">
    <div class="copyright">{{ footerData?.copyright }}</div>
    <div class="footer-links">
      @for (link of footerData?.links; track link) {
      <app-link linkmode="wp-anchor" [to]="link.url" [linkName]="link.label" variant="quiet" size="xs"> </app-link>
      }
      <app-link linkmode="wp-anchor" id="cpra_button" linkName="Privacy Choices" variant="quiet" size="xs"> </app-link>
    </div>
  </div>
</div>
